import React, { useEffect, useState } from "react";
//import "./productstable.css";
import { Link } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from "@mui/material/Button";
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, MenuItem, TextField, ThemeProvider, createTheme } from "@mui/material";
import { DataGrid, GridApi, GridColDef, GridValueGetterParams, GridCellParams } from '@mui/x-data-grid';
import { BrandsService } from "../../service/brands.service";
import { CategoryService } from "../../service/categories.service";
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone';

function SubCategoriesTable() {

  const brandsService = new BrandsService();
  const categoryService = new CategoryService();
  const [selectedSize, setSelectedSize] = useState(1);
  //const [AvailableSizes, setAvailableSizes] = useState<UnitSizes[]>([]);
  const [selectedBrand, setSelectedBrand] = React.useState("select");
  const [selectedMainCategory, setSelectedMainCategory] = React.useState("select");
  const [availableBrands, setAvailableBrands] = useState<any[]>([]);
  const [availableMainCategories, setAvailableMainCategories] = React.useState<any[]>([]);
  const [selectedStatus, setSelectedStatus] = React.useState(99);
  const [availableSubCategories, setAvailableSubCategories] = React.useState<any[]>([]);
  

  //const [availableStatus, setAvailableStatus] = useState<OrderStatus[]>([]);

  const CustomFontTheme = createTheme({
    typography: {
      fontSize: 14
    }
  });

  const navigate = useNavigate();
  
  const toCategoryDetails = (catIndex: string, action: string) => {
    console.log("subcat : ",catIndex , selectedBrand , availableSubCategories[Number(catIndex)-1])

    navigate('../subcategorydetails',{state:{
      selectedBrandId:selectedBrand,
      categoryDetails : availableSubCategories[Number(catIndex)-1],
      brandsData: availableBrands ,
      categoryData: availableMainCategories
    }})
  };


  const [open, setOpen] = React.useState(false);



  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 200 },


    { field: 'catImage', headerName: 'Image', flex: 1, sortable: false, renderCell: (params) => <img src={params.value} width="70" height="70" className="p-2" /> },
    { field: 'catName', headerName: 'Category Name', width: 400 },
    {
      field: 'status', headerName: 'Status', flex: 1,

      renderCell: (params) => {
        return <div>
          {params.value == -1 && (<p style={{ color: "blue" }}>Unknown</p>)
            || params.value == 0 && (<p style={{ color: "red" }}>Deactive</p>)
            || params.value == 1 && (<p style={{ color: "green" }}>Active</p>)
          }

        </div>

      }

    },
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      renderCell: (params) => {
        const onClick = (e: { stopPropagation: () => void; }) => {
          e.stopPropagation(); // don't select this row after clicking

          const api: GridApi = params.api;
          const thisRow: Record<string, GridCellParams> = {};

          api
            .getAllColumns()
            .filter((c: { field: string; }) => c.field !== "__check__" && !!c)
            .forEach(
              (c: { field: string | number; }) => (thisRow[c.field] = params.value.getValue(params.id, c.field))
            );
        };

        return <div>
          <Button onClick={(e) => toCategoryDetails(params.value, "edit")} > <IconButton> <EditTwoToneIcon fontSize="small" /></IconButton></Button>

        </div>
      },
      flex: 1
    }

  ];
  //useEffect(() => {
  const submitRequest = (checkApprovalStatus: number) => {

  }//, [selectedEnterprise, selectedStatus]);

  const loadBrandsData = () => {

    brandsService.brands(1).then(data => {
      const res = data.data;
      //const { unit, sizes } = res.data;
      console.log("^^^^^^^^^^^^^^Unit " + res.length);
      // const unitGroups: any = [];
      /*  for (let index = 0; index < res.length; index++) {
          const unitG = res[index].unit;
          const sizesG = res[index].sizes;
          unitGroups.push({ ...sizesG, unit: unitG, });
        }*/
      console.log("grpp ", res);
      setAvailableBrands(res);

    });

  }

  let isLoadDataInit = false;
  useEffect(() => {

    if (!isLoadDataInit) {
      isLoadDataInit = true;
      loadBrandsData();
    }

  }, [])

  const loadAllCategories = (brand: Number) => {
    // setSelectedMainCategory (0)
    categoryService.categories(Number(brand)).then(data => {
      const res = data.data;
      setAvailableMainCategories(res)
    });
  }

  const loadSubCategories = (scatId: number) => {
    console.log("~~~~~~~~~~~~~~~selectedBrandId:" + selectedBrand + ",sCatId: " + Number(scatId));
    categoryService.subCategories(Number(selectedBrand), scatId).then(data => {
      const res = data.data;
      let cnt = 0;
      const peopleWithImages = res.map((person: any, index: any) => {
        cnt = cnt + 1;
        return {
          ...person,
          id: cnt,
          action: cnt//person.catId,
        };

      });
      setAvailableSubCategories(peopleWithImages)
    }).catch(err => {
      setAvailableSubCategories([]);
    });
  }


  return (
    <><div className="App border card">

      <div className="mt-3 col-md-12 row">
        <div className="col-2 form-group  text-left">
          <ThemeProvider theme={CustomFontTheme}>
            <TextField select size="small" label="Brand Name" id="outlined-start-adornment" InputLabelProps={{ shrink: true }}
              className="form-control" name='brandId' defaultValue="select" value={selectedBrand} 
              onChange={(e: any) => {
                setSelectedBrand(e.target.value);
                loadAllCategories(Number(e.target.value));
              }}
            >
              <MenuItem value="select" key="select">Select</MenuItem>
              {availableBrands.map((_el: any) => <MenuItem key={_el.brandId} value={_el.brandId}> {_el.brandName}</MenuItem>)}
            </TextField>
          </ThemeProvider>
        </div>

        <div className="col-2 form-group  text-left">
          <ThemeProvider theme={CustomFontTheme}>
            <TextField select size="small" label="Main Category" id="outlined-start-adornment" InputLabelProps={{ shrink: true }}
              className="form-control" name='catId' defaultValue="select" value={selectedMainCategory} 
              onChange={(e: any) => {
                setSelectedMainCategory(e.target.value);
                loadSubCategories(Number(e.target.value));
              }}
            >
              <MenuItem value="select" key="select">Select</MenuItem>
              {availableMainCategories.map((_el: any) => <MenuItem key={_el.catId} value={_el.catId}> {_el.catName}</MenuItem>)}
            </TextField>
          </ThemeProvider>
        </div>
        <div className="col-6 form-group ">

        </div>

        <div className="col-2 text-right">
          <Button size="small" style={{ color: "green" }} className="form-control text-right" onClick={() => navigate('../subcategorydetails')} variant="text" startIcon={<AddCircleOutlineTwoToneIcon />}>
            Add New
          </Button>
        </div>
        
      </div>
    </div><div style={{ width: '100%' }}>
        <DataGrid
          // table customization start
          sx={{
            '& .MuiDataGrid-columnHeaderTitle': {
              whiteSpace: "break-spaces", lineHeight: 1, fontSize: "13px", fontWeight: "bold",
            },
            '& .MuiDataGrid-columnHeader': {
              backgroundColor: "#D0D0D0"
            },
            '& .Mui-odd': {
              textOverflow: "inherit", fontSize: "12px", textAlign: "left"
            },

            '& .Mui-even': {
              backgroundColor: "#F7f7f7", textOverflow: "inherit", fontSize: "12px", textAlign: "left"
            },

            '& .Mui-cellown': {
              paddingTop: 0, paddingBottom: 0
            },
          }}

          getCellClassName={(params) => 'Mui-cellown'}
          getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'}
          autoHeight={true}
          getRowHeight={() => 'auto'}

          // table customization
          rows={availableSubCategories}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          pageSizeOptions={[10, 25, 50]} />
      </div></>

  );
}


export default SubCategoriesTable;


